<template>
  <div class="staff-list">
    <!-- 系统管理-职员管理（企业微信手机端，可新增/编辑/删除） -->
    <mobile-list-header>
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchInfo.searchKey" placeholder="职员姓名/电话" @keyup.enter="resetSearch"/>
          <yq-icon v-if="searchInfo.searchKey" class="icon clear" name="element-ui_close" @click="clearKey"/>
        </div>
        <div class="search-btn" @click="resetSearch">搜索</div>
      </div>
      <div class="filter-row">
        <mobile-condition-select v-model="searchInfo.roleId" :data="roleOptions"
                                 label-column="roleName" code-column="id" type="list"
                                 placeholder="角色" @change="resetSearch"/>
      </div>
    </mobile-list-header>

    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList"
                 :refresh="resetSearch" ref="mobileList">
      <list-card class="staff-item" v-for="item in dataList" :key="item.id" :label="item.employeeName || '—'"
                 @click="toDetail(item)">
        <template #desc>
          <yq-icon class="item-arrow" name="element-ui_arrow-right"/>
        </template>
        <data-column label="联系电话">{{ item.employeePhone || "—" }}</data-column>
        <data-column label="角色">{{ item.roleName || "—" }}</data-column>
      </list-card>
    </mobile-list>

    <!-- 悬浮「新增职员」按钮：右下角，可拖动 -->
    <mobile-float-button label="新增职员" icon="element-ui_plus" @click="toCreate"/>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import MobileConditionSelect from "@/components/qywx/data/MobileConditionSelect.vue";
import MobileFloatButton from "@/components/qywx/button/MobileFloatButton.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import staffEmployeeApi from "@/api/dz-crm/sys/staffEmployeeApi";
import roleApi from "@/api/normal/sys/roleApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "StaffEmployeeListQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileFloatButton, MobileConditionSelect, MobileListHeader, MobileList
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        searchKey: "",
        roleId: "",
        pageNumber: 0,
        pageSize: 20,
        hasMore: true, // 初始为 true，列表挂载后由无限滚动自动触发首次查询
      },
      dataList: [],
      roleOptions: [],
    };
  },
  created() {
    roleApi.queryAllRoles().then(list => this.roleOptions = list || []);
  },
  methods: {
    queryList() {
      this.loading = true;
      this.searchInfo.pageNumber++;
      const params = {
        pageNumber: this.searchInfo.pageNumber,
        pageSize: this.searchInfo.pageSize,
      };
      ["searchKey", "roleId"].forEach(key => {
        if (this.searchInfo[key] !== "" && this.searchInfo[key] !== null && this.searchInfo[key] !== undefined) {
          params[key] = this.searchInfo[key];
        }
      });
      staffEmployeeApi.queryList(params).then(res => {
        this.dataList = this.dataList.concat(res.records || []);
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
        this.$refs.mobileList.hideRefreshTitle();
      }).catch(() => {
        this.loading = false;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 0;
      this.dataList = [];
      this.searchInfo.hasMore = true;
      this.queryList();
    },
    clearKey() {
      this.searchInfo.searchKey = "";
      this.resetSearch();
    },
    toDetail(item) {
      this.router.push({
        path: "/qywx/sys/loginuser/detail",
        query: {
          id: item.id,
          employeeId: item.employeeId,
          employeeName: item.employeeName || "",
          employeePhone: item.employeePhone || "",
          roleIds: (item.roleIdArr || []).join(","),
        },
      });
    },
    toCreate() {
      this.router.push("/qywx/sys/loginuser/detail");
    },
  }
};
</script>

<style lang="scss" scoped>
.staff-list{
  height: 100%;
  display: flex;
  flex-direction: column;
  // 悬浮按钮的定位祖先
  position: relative;
}
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.filter-row{
  display: flex;
  gap: 18px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  > *{
    flex: none;
  }
}
.staff-item{
  :deep(.card-title .desc){
    display: flex;
    align-items: center;
  }
  .item-arrow{
    color: var(--yq-font-color-desc);
    font-size: var(--yq-font-size-mini-mobile);
  }
}
</style>
